import SocialSubscriptionErrorModal from '.';

export const loadSocialSubscriptionErrorModal = (jrConfigGlobal: Readonly<JrConfigGlobal> = window.jrConfigGlobal) => {
  new SocialSubscriptionErrorModal(
    'subscription-error',
    'jr-modal-wrapper',
    jrConfigGlobal
  ).init();
}
